<template>
  <div class="home">
    <Navbar/>
    <NavbarCategory/>
    <b-container class="bv-example-row mb-3 mt-1">
      <b-row cols="4">
        <div v-for="product in products" :key="product.id">
          <Card :product="product"/>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
import Card from '../components/Card'
import Navbar from '@/components/Navbar.vue'
import NavbarCategory from '@/components/NavbarCategory.vue'

export default {
  name: 'Home',
  data () {
    return {
      user: this.$store.state.user
    }
  },
  computed: {
    products () {
      return this.$store.state.products
    }
  },
  components: {
    Card, Navbar, NavbarCategory
  },
  methods: {
    fetchAllProducts () {
      this.$store.dispatch('fetchAllProducts')
    },
    fetchAllCarts () {
      if (this.user !== null) {
        this.$store.dispatch('fetchAllCarts')
      }
    }
  },
  created () {
    this.fetchAllProducts()
    this.fetchAllCarts()
  }
}
</script>
